// extracted by mini-css-extract-plugin
export var innerWrapper = "attachments-to-send-list-module--inner-wrapper--OtIIT";
export var item = "attachments-to-send-list-module--item--3IdEP";
export var list = "attachments-to-send-list-module--list--cL4wr";
export var titleHolder = "attachments-to-send-list-module--title-holder--MNc7f";
export var wrapper = "attachments-to-send-list-module--wrapper--2X9uW";